import * as React from 'react';

import './ECheckRowMobile.scss';
import RCheckbox from 'src/components/common/RCheckbox/RCheckbox';

interface IECheckRowMobileProps {
  payment: any;
  onShowDetails: (e: any, payment: any) => void;
  onChangeCheckbox: (payment: any, handleChecked: any) => void;
}

interface IECheckRowMobileState {
  isChecked: boolean;
}
class ECheckRowMobile extends React.Component<
  IECheckRowMobileProps,
  IECheckRowMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isChecked: false
    };
  }

  public componentDidMount = () => {
    const { payment } = this.props;

    if (payment.disposition === 'VT') {
      this.setState({
        isChecked: true
      });
    }
  };

  private handleChecked = () => {
    if (!this.state.isChecked) {
      this.setState({
        isChecked: true
      });
    } else {
      this.setState({
        isChecked: false
      });
    }
  };

  public render() {
    return (
      <div className="rp-echeck-row-mobile row">
        <div className="col-4">
          <h6 className="rp-echeck-row-mobile-header">Payment ID</h6>
          <a
            onClick={e => this.props.onShowDetails(e, this.props.payment)}
            href="#"
            className="rp-echeck-row-mobile-content --tracking-number"
          >
            {this.props.payment.paymentNumber}
          </a>
        </div>
        <div className="col-4">
          <h6 className="rp-echeck-row-mobile-header">Status</h6>
          <span className="rp-echeck-row-mobile-content">
            {this.props.payment.status === 'APPROVED' ? (
              <i className="rpds-check-circle" />
            ) : (
              <i className="rpds-error" />
            )}
            {this.props.payment.status}
          </span>
        </div>
        <div className="col-4">
          <h6 className="rp-echeck-row-mobile-header">Actions</h6>
          <span className="rp-echeck-row-mobile-content">
            <RCheckbox
              id={'1'}
              onChanged={() =>
                this.props.onChangeCheckbox(
                  this.props.payment,
                  this.handleChecked
                )
              }
              color={this.props.payment.taker ? 'gray' : 'green'}
              usesLabel={true}
              label={'VOID'}
              type={'box'}
              checked={this.state.isChecked}
              disabled={this.props.payment.taker ? true : false}
            />
          </span>
        </div>
      </div>
    );
  }
}

export default ECheckRowMobile;
